import { render, staticRenderFns } from "./Forcedupdate.vue?vue&type=template&id=6608026b&"
import script from "./Forcedupdate.vue?vue&type=script&lang=js&"
export * from "./Forcedupdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports